/* ds-size-wizard.js : Einheitlicher PDP-Groessenfinder fuer alle Dogs-Supreme-Geschirre.
   Brustumfang-first (Master-Tabelle = snippets/ds-size-chart.liquid, Quelle SIZE-CHART-OF-RECORD.md).
   Gewicht optional als Plausibilitaets-Check. Cross-Produkt-Routing statt Sackgasse.
   Kein Auto-Snap auf Nachbar-Groessen: ausverkauft = ehrlich sagen + Back-in-Stock-Pfad.
   Pure Logik in DSW.recommend() : wird von tests/ds-size-wizard.test.js direkt geladen. */
(function () {
  'use strict';

  /* Master-Tabelle. MUSS wortgleich zu snippets/ds-size-chart.liquid bleiben.
     cm = Brustumfang (massgeblich), kg = Referenz-Gewicht (nur Orientierung). */
  var MASTER = [
    { key: '3XS', cmMin: 26.7, cmMax: 30.1, kgMin: 1.5, kgMax: 3.0 },
    { key: '2XS', cmMin: 30.2, cmMax: 33.8, kgMin: 2.0, kgMax: 4.0 },
    { key: 'XS',  cmMin: 33.9, cmMax: 38.2, kgMin: 3.5, kgMax: 5.5 },
    { key: 'S',   cmMin: 38.3, cmMax: 43.3, kgMin: 4.5, kgMax: 8.0 },
    { key: 'M',   cmMin: 43.4, cmMax: 49.0, kgMin: 6.5, kgMax: 10.5 },
    { key: 'L',   cmMin: 49.1, cmMax: 55.4, kgMin: 9.0, kgMax: 13.0 },
    { key: 'XL',  cmMin: 55.5, cmMax: 62.7, kgMin: 11.5, kgMax: 18.0 },
    { key: '2XL', cmMin: 62.8, cmMax: 70.1, kgMin: 16.5, kgMax: 24.0 },
    { key: '3XL', cmMin: 70.2, cmMax: 78.9, kgMin: 22.0, kgMax: 31.0 },
    { key: '4XL', cmMin: 79.0, cmMax: 92.0, kgMin: 28.0, kgMax: 48.0 }
  ];

  /* Shopify-Varianten-Codes -> Master-Key (Naming-Drift XXXS/3XS) */
  var CODE_TO_KEY = { 'XXXS': '3XS', 'XXS': '2XS', '3XS': '3XS', '2XS': '2XS' };
  var BORDER_CM = 1.0;       /* Naehe zur Range-Grenze, ab der wir zum Nachmessen raten */
  var EPS = 0.05;            /* Rundungs-Toleranz fuer Range-Vergleiche */

  function keyForCode(code) {
    var up = String(code || '').trim().toUpperCase();
    return CODE_TO_KEY[up] || up;
  }
  function masterIndex(key) {
    for (var i = 0; i < MASTER.length; i++) { if (MASTER[i].key === key) { return i; } }
    return -1;
  }
  function findByCm(cm) {
    for (var i = 0; i < MASTER.length; i++) {
      if (cm >= MASTER[i].cmMin - EPS && cm <= MASTER[i].cmMax + EPS) { return i; }
    }
    return -1;
  }
  function kgIndexSet(kg) {
    var set = [];
    for (var i = 0; i < MASTER.length; i++) {
      if (kg >= MASTER[i].kgMin - EPS && kg <= MASTER[i].kgMax + EPS) { set.push(i); }
    }
    return set;
  }

  /* productSizes: [{ code, key, available, variantId }] aus Liquid.
     Liefert Eintrag fuer Master-Key oder null. */
  function productSize(cfg, key) {
    var list = cfg.productSizes || [];
    for (var i = 0; i < list.length; i++) { if (list[i].key === key) { return list[i]; } }
    return null;
  }
  /* Cross-Target: { handle, title, url, sizes: [{key, available, variantId}] } */
  function targetSize(target, key) {
    if (!target || !target.sizes) { return null; }
    for (var i = 0; i < target.sizes.length; i++) { if (target.sizes[i].key === key) { return target.sizes[i]; } }
    return null;
  }

  /* Cross-Routing: welches Produkt traegt diese Master-Groesse?
     klein-Familie: 1. Air Mesh Pro (Familien-Vollsortimenter), 2. Comfort Pro, 3. Comfort Basic.
     gross-Familie: 1. Comfort Pro, 2. Comfort Basic (gleiches Einsatzprofil), 3. Air Mesh Pro.
     Eigenes Produkt wird uebersprungen. Nie Auslaufmodelle (Targets kuratiert aus Liquid). */
  function crossFor(cfg, key) {
    var order = (cfg.family === 'large')
      ? [cfg.targets.large, cfg.targets.largeAlt, cfg.targets.small]
      : [cfg.targets.small, cfg.targets.large, cfg.targets.largeAlt];
    var fallback = null;
    for (var i = 0; i < order.length; i++) {
      var t = order[i];
      if (!t || t.handle === cfg.productHandle) { continue; }
      var s = targetSize(t, key);
      if (s && s.available) { return { target: t, size: s, available: true }; }
      if (s && !fallback) { fallback = { target: t, size: s, available: false }; }
    }
    return fallback;
  }

  /* Kern: Empfehlung aus { cm, kg, mode } gegen Produkt-Konfiguration.
     mode 'cm' (Standard) | 'kg' (expliziter Fallback "kann nicht messen").
     Rueckgabe: { type, sizeKey, size, border, mismatch, cross, alt, kgHint } */
  function recommend(input, cfg) {
    var res = { type: null, sizeKey: null, size: null, border: null, mismatch: null, cross: null, alt: null, kgHint: null, mode: input.mode || 'cm' };

    if (res.mode === 'kg') {
      var kg = input.kg;
      if (!(kg > 0)) { res.type = 'invalid'; return res; }
      var set = kgIndexSet(kg);
      if (!set.length) {
        if (kg < MASTER[0].kgMin) { res.type = 'puppy'; return res; }
        res.type = 'over_range'; return res;
      }
      /* Defensiv: Retouren-Daten 2025/26 sind ausschliesslich "zu klein bestellt" ->
         bei mehrdeutigem Gewicht die GROESSERE Range empfehlen, kleinere als Alternative nennen. */
      var idxKg = set[set.length - 1];
      res.sizeKey = MASTER[idxKg].key;
      res.kgHint = set.length > 1 ? MASTER[set[0]].key : null;
      return finishProductMatch(res, cfg, idxKg);
    }

    var cm = input.cm;
    if (!(cm > 0)) { res.type = 'invalid'; return res; }
    if (cm < MASTER[0].cmMin - EPS) { res.type = 'puppy'; return res; }
    if (cm > MASTER[MASTER.length - 1].cmMax + EPS) { res.type = 'over_range'; return res; }

    var idx = findByCm(cm);
    if (idx < 0) { res.type = 'invalid'; return res; }
    res.sizeKey = MASTER[idx].key;

    /* Grenz-Naehe: Messfehler von 1 cm kippt die Groesse -> Nachmess-Hinweis + Nachbar */
    var m = MASTER[idx];
    if (idx > 0 && (cm - m.cmMin) < BORDER_CM) { res.border = { neighborKey: MASTER[idx - 1].key, dir: 'down' }; }
    else if (idx < MASTER.length - 1 && (m.cmMax - cm) < BORDER_CM) { res.border = { neighborKey: MASTER[idx + 1].key, dir: 'up' }; }

    /* Plausibilitaets-Check Gewicht (optional). Asymmetrisch:
       cm-Groesse >=2 Stufen UNTER kg-Plausibilitaet -> Verdacht "zu klein gemessen" (Hals/Bauch
       statt Brustkorb). Umgekehrt (kompakter Hund, dickes Fell) ist normal -> kein Alarm. */
    if (input.kg > 0) {
      var kset = kgIndexSet(input.kg);
      if (kset.length) {
        if (idx <= kset[0] - 2) { res.mismatch = { dir: 'cm_low', kgKey: MASTER[kset[0]].key }; }
        /* kg als Schiedsrichter im Grenzfall */
        if (res.border) {
          var nIdx = masterIndex(res.border.neighborKey);
          var inIdx = kset.indexOf(idx) >= 0, inN = kset.indexOf(nIdx) >= 0;
          if (inIdx && !inN) { res.border.verdict = res.sizeKey; }
          else if (inN && !inIdx) { res.border.verdict = res.border.neighborKey; }
        }
      }
    }
    return finishProductMatch(res, cfg, idx);
  }

  /* Produkt-Zuordnung: traegt das aktuelle Produkt die Groesse? Sonst Cross-Routing. */
  function finishProductMatch(res, cfg, idx) {
    var key = MASTER[idx].key;
    var own = productSize(cfg, key);
    if (own) {
      res.size = own;
      res.type = own.available ? 'match' : 'match_oos';
      if (!own.available) {
        /* Ehrliche Alternative nur, wenn ein Schwester-Produkt dieselbe Groesse verfuegbar hat */
        res.alt = crossFor(cfg, key);
        if (res.alt && !res.alt.available) { res.alt = null; }
      }
      return res;
    }
    /* Produkt fuehrt die Groesse nicht -> anderes Geschirr empfehlen */
    res.cross = crossFor(cfg, key);
    res.type = res.cross ? 'cross' : 'no_product';
    return res;
  }

  var DSW = { MASTER: MASTER, recommend: recommend, keyForCode: keyForCode, findByCm: findByCm, kgIndexSet: kgIndexSet };

  /* ---------- DOM-Schicht (Browser only) ---------- */
  function initWidget(root) {
    if (root.__dswInit) { return; }
    root.__dswInit = true;

    var cfgEl = root.querySelector('[data-dsw-config]');
    if (!cfgEl) { return; }
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    /* Varianten-Codes -> Master-Keys normalisieren */
    (cfg.productSizes || []).forEach(function (s) { s.key = keyForCode(s.code); });
    ['small', 'large', 'largeAlt'].forEach(function (k) {
      var t = (cfg.targets || {})[k];
      if (t && t.sizes) { t.sizes.forEach(function (s) { s.key = keyForCode(s.code); }); }
    });

    var q = function (sel) { return root.querySelector(sel); };
    var trigger = q('[data-dsw-open]');
    var backdrop = q('[data-dsw-backdrop]');
    var closeBtn = q('[data-dsw-close]');
    var backBtn = q('[data-dsw-back]');
    var form = q('[data-dsw-form]');
    var result = q('[data-dsw-result]');
    var cmInput = q('[data-dsw-cm]');
    var kgInput = q('[data-dsw-kg]');
    var kg2Input = q('[data-dsw-kg2]');
    var submit = q('[data-dsw-submit]');
    var kgModeLink = q('[data-dsw-kg-mode]');
    var cmModeLink = q('[data-dsw-cm-mode]');
    var kgOnlyWrap = q('[data-dsw-kg-only]');
    var cmWrap = q('[data-dsw-cm-wrap]');
    var resBody = q('[data-dsw-result-body]');
    var mode = 'cm';

    if (!trigger || !backdrop) { return; }
    requestAnimationFrame(function () { backdrop.classList.add('dsw-ready'); });

    function track(name, params) {
      try {
        window.dataLayer = window.dataLayer || [];
        var p = Object.assign({ event: name, wizard: 'ds-size-wizard-v2', product_handle: cfg.productHandle }, params || {});
        window.dataLayer.push(p);
      } catch (e) { /* silent */ }
    }

    function toggleModal(show) {
      backdrop.classList.toggle('dsw-open', show);
      document.body.style.overflow = show ? 'hidden' : '';
      if (show) {
        showView('form');
        setTimeout(function () { if (mode === 'cm') { cmInput.focus(); } else { kg2Input.focus(); } }, 120);
        track('size_wizard_opened', {});
      }
    }
    function showView(which) {
      form.hidden = which !== 'form';
      result.hidden = which !== 'result';
      backBtn.hidden = which !== 'result';
    }
    function setMode(m) {
      mode = m;
      cmWrap.hidden = m !== 'cm';
      kgOnlyWrap.hidden = m !== 'kg';
      if (m === 'kg') { track('size_wizard_weight_fallback', {}); setTimeout(function(){ kg2Input.focus(); }, 60); }
      else { setTimeout(function(){ cmInput.focus(); }, 60); }
    }

    function num(el) {
      if (!el || !el.value) { return null; }
      var v = parseFloat(String(el.value).replace(',', '.'));
      return isFinite(v) && v > 0 ? v : null;
    }

    /* Variante auf der PDP setzen. Selektoren = bewiesene Alt-Implementierung
       (apple-size-wizard.liquid): das Theme rendert die Groessen-Radios in einem <fieldset>
       AUSSERHALB der cart-form (form-Attribut-Assoziation), theme.js hoert auf Radio-Clicks.
       KEIN disabled-Check: ausverkaufte Pills sind klickbar, genau so erscheint das
       Back-in-Stock-Widget (variant:change mit available=false). */
    function applyVariant(code) {
      var target = String(code).toUpperCase();
      var done = false;
      document.querySelectorAll('fieldset input[type="radio"], fieldset input[type="checkbox"]').forEach(function (r) {
        if (done) { return; }
        if (r.value && r.value.toUpperCase() === target) { r.click(); done = true; }
      });
      if (!done) {
        document.querySelectorAll('select option').forEach(function (o) {
          if (done) { return; }
          if (o.value.toUpperCase() === target || o.textContent.trim().toUpperCase() === target) {
            var sel = o.closest('select'); if (!sel) { return; }
            sel.value = o.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            done = true;
          }
        });
      }
      if (!done) {
        document.querySelectorAll('label').forEach(function (l) {
          if (done) { return; }
          if (l.textContent.trim().toUpperCase() === target) { l.click(); done = true; }
        });
      }
      return done;
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function rangeText(key) {
      var i = masterIndex(key);
      if (i < 0) { return ''; }
      var m = MASTER[i];
      /* eine Dezimalstelle wie in der Groessentabelle (49,0 statt 49) */
      return m.cmMin.toFixed(1).replace('.', ',') + ' bis ' + m.cmMax.toFixed(1).replace('.', ',') + ' cm';
    }
    function codeFor(key) {
      var own = productSize(cfg, key);
      return own ? own.code : key;
    }

    var WARN_IC = '<svg class="dsw-warn-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';
    function warnHtml(text) { return '<div class="dsw-warn">' + WARN_IC + '<span>' + esc(text) + '</span></div>'; }

    /* Ergebnis-Panel bauen. Nur aus esc()-behandelten Daten + statischen Strings. */
    function renderResult(r, input) {
      var h = '';
      var t = cfg.texts || {};

      if (r.type === 'invalid') {
        h = '<div class="dsw-rcard"><p class="dsw-msg">' + esc(t.invalid || 'Bitte gib einen Wert ein.') + '</p></div>';
      } else if (r.type === 'puppy') {
        h = '<div class="dsw-rcard"><p class="dsw-msg">' + esc(t.puppy) + '</p></div>';
      } else if (r.type === 'over_range' || r.type === 'no_product') {
        h = '<div class="dsw-rcard"><p class="dsw-msg">' + esc(t.overRange) + '</p></div>';
      } else {
        var sizeLabel = esc(codeFor(r.sizeKey) || r.sizeKey);

        if (r.type === 'match' || r.type === 'match_oos') {
          h += '<div class="dsw-rcard">';
          h += '<p class="dsw-kicker">Deine Empfehlung</p>';
          h += '<div class="dsw-size-badge">' + sizeLabel + '</div>';
          if (r.mode === 'kg') {
            h += '<p class="dsw-reason">' + esc((t.kgReason || 'Grobe Schätzung nach Gewicht.')) + '</p>';
            if (r.kgHint) { h += '<p class="dsw-note">' + esc(t.kgSlimHint || 'Sehr schlanker Hund? Dann eher Größe') + ' ' + esc(r.kgHint) + '.</p>'; }
            h += warnHtml(t.kgWarn);
          } else {
            h += '<p class="dsw-reason">' + esc(t.reasonPrefix) + ' ' + esc(String(input.cm).replace('.', ',')) + ' cm ' + esc(t.reasonMid) + ' ' + esc(rangeText(r.sizeKey)) + '.</p>';
          }
          if (r.mismatch) { h += warnHtml(t.mismatch); }
          if (r.border && r.mode === 'cm') {
            var bTxt = (t.border || '').replace('{n}', r.border.neighborKey);
            if (r.border.verdict) { bTxt += ' ' + (t.borderVerdict || 'Dein angegebenes Gewicht spricht für Größe {v}.').replace('{v}', r.border.verdict); }
            h += '<p class="dsw-note">' + esc(bTxt) + '</p>';
          }
          if (r.type === 'match_oos') { h += '<p class="dsw-oos">' + esc(t.oos) + '</p>'; }
          h += '</div>';

          if (r.type === 'match') {
            h += '<button type="button" class="dsw-cta" data-dsw-apply="' + esc(r.size.code) + '">' + esc((t.applyBtn || 'Größe {s} auswählen').replace('{s}', r.size.code)) + '</button>';
          } else {
            h += '<button type="button" class="dsw-cta" data-dsw-apply="' + esc(r.size.code) + '" data-dsw-bis="1">' + esc(t.oosBtn) + '</button>';
            if (r.alt && r.alt.available) {
              h += crossCard(r.alt, t, t.altLead || 'Sofort lieferbar als Alternative:');
            }
          }
        } else if (r.type === 'cross') {
          var lead = (r.mode === 'kg')
            ? (t.crossLeadKg || '').replace('{p}', cfg.productTitle)
            : (t.crossLead || '').replace('{p}', cfg.productTitle).replace('{cm}', String(input.cm || '').replace('.', ','));
          h += '<div class="dsw-rcard">';
          h += '<p class="dsw-kicker">Deine Empfehlung</p>';
          h += '<p class="dsw-msg">' + esc(lead) + '</p>';
          h += crossCard(r.cross, t, null);
          if (!r.cross.available) { h += '<p class="dsw-note">' + esc(t.crossOos) + '</p>'; }
          if (r.mode === 'kg') { h += warnHtml(t.kgWarn); }
          if (r.mismatch) { h += warnHtml(t.mismatch); }
          h += '</div>';
        }
      }
      resBody.innerHTML = h;

      resBody.querySelectorAll('[data-dsw-apply]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var ok = applyVariant(btn.getAttribute('data-dsw-apply'));
          track('size_wizard_variant_selected', { size: btn.getAttribute('data-dsw-apply'), found: ok, oos_bis: btn.hasAttribute('data-dsw-bis') });
          toggleModal(false);
          if (btn.hasAttribute('data-dsw-bis')) {
            setTimeout(function () {
              var bis = document.querySelector('.ds-bis.is-visible');
              if (bis) { bis.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
            }, 350);
          }
        });
      });
      resBody.querySelectorAll('[data-dsw-cross]').forEach(function (a) {
        a.addEventListener('click', function () {
          track('size_wizard_cross_click', { target_handle: a.getAttribute('data-dsw-cross'), size: r.sizeKey });
        });
      });
    }

    function crossCard(cross, t, leadText) {
      var c = '';
      if (leadText) { c += '<p class="dsw-note">' + esc(leadText) + '</p>'; }
      var sizeCode = cross.size ? cross.size.code : '';
      var href = cross.target.url + (cross.size && cross.size.variantId ? '?variant=' + cross.size.variantId : '');
      c += '<a class="dsw-cross-card" href="' + esc(href) + '" data-dsw-cross="' + esc(cross.target.handle) + '">';
      if (cross.target.image) { c += '<img class="dsw-cross-img" src="' + esc(cross.target.image) + '" alt="" loading="lazy">'; }
      c += '<span class="dsw-cross-info"><span class="dsw-cross-title">' + esc(cross.target.title) + '</span>';
      var price = cross.target.priceFrom ? String(cross.target.priceFrom).replace(/\s+/g, ' ').trim() : '';
      c += '<span class="dsw-cross-sub">' + esc((t.crossSize || 'In der passenden Größe {s}').replace('{s}', sizeCode)) + (price ? ' · ab ' + esc(price) : '') + '</span></span>';
      c += '<span class="dsw-cross-arrow" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></span></a>';
      return c;
    }

    function calculate() {
      var cm = num(cmInput), kg = mode === 'kg' ? num(kg2Input) : num(kgInput);
      var input = mode === 'kg' ? { kg: kg, mode: 'kg' } : { cm: cm, kg: kg, mode: 'cm' };
      if ((mode === 'cm' && !cm) || (mode === 'kg' && !kg)) {
        (mode === 'cm' ? cmInput : kg2Input).classList.add('dsw-input-err');
        return;
      }
      [cmInput, kgInput, kg2Input].forEach(function (el) { if (el) { el.classList.remove('dsw-input-err'); } });
      var r = recommend(input, cfg);
      track('size_wizard_calculated', { cm: cm, kg: kg, mode: mode });
      track('size_wizard_recommendation', { recommended: r.sizeKey, result_type: r.type, mode: mode });
      renderResult(r, input);
      showView('result');
    }

    trigger.addEventListener('click', function (e) { e.preventDefault(); toggleModal(true); });
    closeBtn.addEventListener('click', function (e) { e.preventDefault(); toggleModal(false); });
    backBtn.addEventListener('click', function (e) { e.preventDefault(); showView('form'); });
    backdrop.addEventListener('click', function (e) { if (e.target === backdrop) { toggleModal(false); } });
    submit.addEventListener('click', function (e) { e.preventDefault(); calculate(); });
    [cmInput, kgInput, kg2Input].forEach(function (el) {
      if (!el) { return; }
      el.addEventListener('keypress', function (e) { if (e.key === 'Enter') { e.preventDefault(); calculate(); } });
    });
    if (kgModeLink) { kgModeLink.addEventListener('click', function (e) { e.preventDefault(); setMode('kg'); }); }
    if (cmModeLink) { cmModeLink.addEventListener('click', function (e) { e.preventDefault(); setMode('cm'); }); }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-dsw-root]');
    if (!roots.length) { return; }
    /* Shadow-Phase: v2 nur mit ?ds_wizard=v2 sichtbar, sonst bleibt v1 aktiv.
       Nach GF-Go wird dieser Block durch bedingungsloses Aktivieren ersetzt. */
    var shadow = false;
    try { shadow = new URLSearchParams(window.location.search).get('ds_wizard') === 'v2'; } catch (e) { /* old browser */ }
    roots.forEach(function (root) {
      var isShadow = root.getAttribute('data-dsw-shadow') === '1';
      if (isShadow && !shadow) { return; }
      if (isShadow && shadow) {
        /* Aktivierung: Attribut + Inline-Style entfernen (CSS-Regel haengt am Attribut).
           .sw-wrapper-Hide ist dokumentweit ok: boot() laeuft nur auf Seiten MIT dsw-root
           (= Geschirr-PDPs), und dort existiert genau ein Alt-Wizard. Schutzhose/FlexBox/
           Hundebar-PDPs haben kein dsw-root und bleiben unberuehrt. */
        root.removeAttribute('data-dsw-shadow');
        root.style.display = '';
        document.querySelectorAll('.sw-wrapper').forEach(function (el) { el.style.display = 'none'; });
      }
      initWidget(root);
    });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') { boot(); }
    else { document.addEventListener('DOMContentLoaded', boot); }
    window.DSW = DSW;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = DSW; }
})();
